var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMentalHealthScreeningFilled = function SvgMentalHealthScreeningFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.633 12.537-1.55-3.115a7.483 7.483 0 0 0-2.24-5.246A7.494 7.494 0 0 0 11.544 2h-.047C7.337 2.025 3.975 5.43 4 9.59a7.69 7.69 0 0 0 2.398 5.52v4.127c0 .222.148.42.363.48l7.027 2.013a.503.503 0 0 0 .637-.48v-1.998h1.816a2.746 2.746 0 0 0 2.843-2.653v-1.941h.195a1.46 1.46 0 0 0 1.513-1.362 1.47 1.47 0 0 0-.16-.756v-.003Zm-9.643-1.584L8.816 12.37v-1.434c-.886-.083-1.306-.78-1.316-1.44V7.1c0-.987.767-1.444 1.481-1.454h5.034c1.004 0 1.474.752 1.484 1.454v2.4c0 .987-.767 1.447-1.484 1.454H10.99Z",
    fill: "#000"
  })));
};
export default SvgMentalHealthScreeningFilled;